import React, { useContext } from "react";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import { MatchContext } from "../../context";
import { useStyles } from "./styles";
import {
  MATCHING_MIN_DATE_RANGE,
  MATCHING_MIN_RANGE_DAYS,
} from "../../constants";

export default function TimeRangePicker({
  handleStartChange,
  handleEndChange,
}) {
  const classes = useStyles();
  const { state } = useContext(MatchContext);

  return (
    <React.Fragment>
      <InputLabel id="time-select">Time frame</InputLabel>
      <form className={classes.container} noValidate>
        <TextField
          id="time-start"
          value={state.startDate}
          type="date"
          className={classes.textFieldLeft}
          onChange={handleStartChange}
          InputLabelProps={{
            shrink: true,
          }}
        />
        -
        <TextField
          id="time-end"
          value={state.endDate}
          type="date"
          className={classes.textFieldRight}
          onChange={handleEndChange}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </form>
      {new Date(state.endDate).getTime() - new Date(state.startDate).getTime() <
      MATCHING_MIN_DATE_RANGE ? (
        <div className={classes.lessThan}>
          Less than {MATCHING_MIN_RANGE_DAYS} days, increase range for better
          results
        </div>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}
